import { combineReducers } from 'redux';

import list from './list/reducer';
import lastChatMessageId from './lastChatMessageId/reducer';
import chatMessagesBuffer from './chatMessagesBuffer/reducer';

export default combineReducers({
  list,
  lastChatMessageId,
  chatMessagesBuffer
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatItems/reducer.js
 **/